var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-content-admin',[_c('template',{slot:"header"},[_vm._v(_vm._s(_vm.$t("M00423")))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }